module.exports = __webpack_public_path__ + "static/media/peable.0d03a5e2.png";